import CardContainer from '@/components/cards/CardContainer';
import Container, {
	Column,
	Column as FlexColumn,
} from '@/components/container/Container';
import SimpleTable from '@/components/table/SimpleTable';
import { CustomText, TextLabelLarge } from '@/components/text/Texts';
import LoadingProgressBar from '@/components/utils/LoadingProgressBar';
import { AVERAGE_SPEND_PER_COMPLETE_REQUEST } from '@/constants/insights-page';
import CardContentSkeleton from './CardContentSkeleton';
import EmptyScreen from './EmptyScreen';
import { formatCurrency } from '@/common/common_utils';

type Props = {
	hasError: boolean | null;
	hasData: boolean | null;
	isLoaded: boolean;
	data: {
		product: string;
		amount: string;
	}[];
};

const AverageSpendSection = ({ hasData, hasError, isLoaded, data }: Props) => {
	//const average = '₱1,502.65';

	const columns = [
		{ field: 'product', header: 'Product' },
		{ field: 'amount', header: 'Amount' },
	];

	const checkState = () => {
		if (hasData === null || hasError == null)
			return (
				<Column gap="gap-4">
					<Container className="-mt-6">
						<LoadingProgressBar />
					</Container>
					<CardContentSkeleton />
				</Column>
			);

		if (!hasData) {
			return <EmptyScreen isError={hasData} height="h-[470px]" />;
		}

		if (hasError) {
			return (
				<EmptyScreen
					isError={hasData}
					// hasError={hasError}
					height="h-[470px]"
				/>
			);
		}
	};

	return (
		<CardContainer>
			<Container className="p-6 bg-white rounded-[24px]">
				{!isLoaded ? (
					checkState()
				) : (
					<FlexColumn gap="gap-4">
						<FlexColumn gap="gap-2">
							<TextLabelLarge
								className="text-black"
								text={AVERAGE_SPEND_PER_COMPLETE_REQUEST}
							/>
							<CustomText
								className="text-primary font-medium text-[44px] leading-[52px]"
								// [0] is fine for now, since we have no programs in fact
								text={data[0].amount}
							/>
						</FlexColumn>
						<SimpleTable data={data} columns={columns} />
					</FlexColumn>
				)}
			</Container>
		</CardContainer>
	);
};

export default AverageSpendSection;
